import { SyntheticEvent, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { RootState } from '../../store';
import { resetPassword } from '../../services/authentication';
import SusyButton from '../shared/buttons/SusyButton';
import { unauthenticatedPaths } from '../../router/constants/route-paths';
import { AuthPageWrapper } from './Wrapper/authPageWrapper/AuthPageWrapper';
import SusyFormField from '../shared/forms/SusyFormField/SusyFormField';
import SusyInput from '../shared/forms/SusyInput';

import ValidationUtils from 'susy-common/validation-utils';

const ForgotPassword = () => {
    const emailRef = useRef<HTMLInputElement>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.authentication
                .forgotPassword
    );

    const navigate = useNavigate();

    const forgotPasswordHandler = async (event: SyntheticEvent) => {
        event.preventDefault();

        if (isSubmitting) {
            return;
        }

        const email = emailRef.current?.value ?? '';

        if (ValidationUtils.isEmailValid(email)) {
            setIsSubmitting(true);
            try {
                await resetPassword(email);
            } catch {
                setIsSubmitting(false);
                return;
            }

            toast.success(localization.successful);
            navigate(unauthenticatedPaths.signIn);
        } else {
            toast.warning(localization.invalidEmail);
        }
    };

    return (
        <AuthPageWrapper
            title={localization.headline}
            subtitle={localization.subtitle}
        >
            <form onSubmit={forgotPasswordHandler}>
                <SusyFormField
                    required
                    label={{
                        fieldIdentifier: 'email',
                        text: localization.email,
                    }}
                >
                    <SusyInput
                        className='form-control mb-4'
                        dataTestId={'email-input'}
                        type='text'
                        name='email'
                        id='email'
                        ref={emailRef}
                        disabled={isSubmitting}
                    />
                </SusyFormField>
                <SusyButton
                    text={localization.resetBtn}
                    classes='mt-3'
                    fullWidth
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    htmlAttributes={{ type: 'submit' }}
                />
            </form>
        </AuthPageWrapper>
    );
};

export default ForgotPassword;
